import { useFormikContext } from "formik";
import "./ActionButtons.css";

export const AddKidButton = ({
  onAdd,
  price,
  currencySymbol = "₹",
  billingPeriod = "/year",
  disabled = false,
  remainingSlots,
}) => {
  return (
    <div className="actionButtons__addWrap">
      <button
        type="button"
        className="actionButtons__addBtn"
        onClick={onAdd}
        disabled={disabled}
      >
        <img src="https://d2lvj32mp5x83n.cloudfront.net/static/homev2/add.png" alt="Add Icon" height={"25px"} />
        {disabled ? (
          "Maximum students reached"
        ) : (
          <span>
            + Add Kid for {currencySymbol}{price}
            {billingPeriod && (
              <span className="actionButtons__billingPeriod">
                {billingPeriod}
              </span>
            )}
          </span>
        )}
      </button>
      {typeof remainingSlots === "number" && (
        <span className="actionButtons__slotsInfo">
          {remainingSlots > 0
            ? `${remainingSlots} slot${remainingSlots !== 1 ? "s" : ""} remaining`
            : "No slots remaining"}
        </span>
      )}
    </div>
  );
};

export const ContinuePayButton = ({
  isSubmitting,
  totalPrice = 0,
  currencySymbol = "₹",
  billingPeriod = "/year",
}) => {
  const { validateForm, setTouched, submitForm } = useFormikContext();

  const handleClick = async () => {
    const errors = await validateForm();
    const hasErrors = Object.keys(errors).length > 0;

    if (hasErrors) {
      // Mark all fields as touched so error messages show
      const touchedFields = {};
      if (errors.kids) {
        touchedFields.kids = errors.kids.map((kidErrors) => {
          if (!kidErrors) return {};
          const touched = {};
          Object.keys(kidErrors).forEach((key) => {
            touched[key] = true;
          });
          return touched;
        });
      }
      setTouched(touchedFields);

      // Find and scroll to the first error field
      // Small timeout to let error messages render first
      setTimeout(() => {
        const firstErrorEl = document.querySelector(".kidDetailsForm__error");
        if (firstErrorEl) {
          firstErrorEl.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
    } else {
      submitForm();
    }
  };

  return (
    <div className="actionButtons__payWrap">
      <button
        type="button"
        className="actionButtons__payBtn"
        disabled={isSubmitting}
        onClick={handleClick}
      >
        {isSubmitting ? (
          "Processing..."
        ) : (
          <span>
            Continue to Pay
            {totalPrice > 0 && (
              <>
                {" — "}
                {currencySymbol}
                {totalPrice}
                {billingPeriod && (
                  <span className="actionButtons__billingPeriod">
                    {billingPeriod}
                  </span>
                )}
              </>
            )}
          </span>
        )}
      </button>
    </div>
  );
};
